import React from 'react';
import './Profile.css';
import icon from '../../assets/images/profile-icon.svg';

// Component containing customer name and email and generic profile icon.
export default function ProfileBadge(props) {
    return (
        <div className="profile-badge">
            <img src={icon} alt="Profile Icon" />
            <p className="customer-name">{props.customer.firstName} {props.customer.lastName}</p>
            <p className="customer-email">{props.customer.email}</p>
        </div>
    );
}
